import { dictionaryLinks } from "./DictionaryLinks.slice";

export const dictionaryLinksActions = { ...dictionaryLinks.actions };
